import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  public setValue(key, value: unknown): void {
    localStorage.setItem(key, JSON.stringify(value));
  }

  public getValue<R>(key): R | null {
    return JSON.parse(localStorage.getItem(key)) as R | null;
  }

  private removeValue(key): void {
    localStorage.removeItem(key);
  }
}
